export default "__VITE_ASSET__i2uD9ufJ__"